var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6133 8.22656C25.2799 10.0799 27.12 13.0266 27.4933 16.4266",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6543 16.493C5.00096 13.1063 6.8143 10.1596 9.4543 8.29297",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9199 27.9199C12.4666 28.7066 14.2266 29.1466 16.0799 29.1466C17.8666 29.1466 19.5466 28.7466 21.0533 28.0133",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0797 10.2668C18.1269 10.2668 19.7864 8.60732 19.7864 6.56018C19.7864 4.51305 18.1269 2.85352 16.0797 2.85352C14.0326 2.85352 12.373 4.51305 12.373 6.56018C12.373 8.60732 14.0326 10.2668 16.0797 10.2668Z",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44007 26.5598C8.4872 26.5598 10.1467 24.9003 10.1467 22.8532C10.1467 20.806 8.4872 19.1465 6.44007 19.1465C4.39293 19.1465 2.7334 20.806 2.7334 22.8532C2.7334 24.9003 4.39293 26.5598 6.44007 26.5598Z",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5602 26.5598C27.6073 26.5598 29.2669 24.9003 29.2669 22.8532C29.2669 20.806 27.6073 19.1465 25.5602 19.1465C23.513 19.1465 21.8535 20.806 21.8535 22.8532C21.8535 24.9003 23.513 26.5598 25.5602 26.5598Z",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnions);
export default __webpack_public_path__ + "static/media/unions.ab27b885.svg";
export { ForwardRef as ReactComponent };